"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketKeepAliveBrokerService = void 0;
class WebSocketKeepAliveBrokerService {
    constructor($rootScope) {
        this.$rootScope = $rootScope;
    }
    static factory($rootScope) {
        return new WebSocketKeepAliveBrokerService($rootScope);
    }
    init(socket) {
        this.$rootScope.webSocketKeepAliveBroker = {
            lastAckAt: Date.now(),
            awaitingAck: false,
            blocked: false,
            socket: socket,
            watchdogInitiated: false,
        };
    }
    acknowledge(socket) {
        var broker = this.$rootScope.webSocketKeepAliveBroker;
        if (!broker || (socket && broker.socket !== socket)) {
            return;
        }
        broker.lastAckAt = Date.now();
        broker.awaitingAck = false;
        broker.blocked = false;
    }
    markAwaitingAck(socket) {
        var broker = this.$rootScope.webSocketKeepAliveBroker;
        if (broker && broker.socket === socket) {
            broker.awaitingAck = true;
        }
    }
    isAwaitingAck(socket) {
        var broker = this.$rootScope.webSocketKeepAliveBroker;
        return !!broker && broker.socket === socket && broker.awaitingAck;
    }
    block(socket) {
        var broker = this.$rootScope.webSocketKeepAliveBroker;
        if (broker && broker.socket === socket) {
            broker.blocked = true;
        }
    }
    isBlocked(socket) {
        var broker = this.$rootScope.webSocketKeepAliveBroker;
        return !!broker && broker.socket === socket && broker.blocked;
    }
    getLastAckAt(socket) {
        var broker = this.$rootScope.webSocketKeepAliveBroker;
        return broker && broker.socket === socket ? broker.lastAckAt : 0;
    }
    markWatchdogInitiated(socket) {
        var broker = this.$rootScope.webSocketKeepAliveBroker;
        if (broker && broker.socket === socket) {
            broker.watchdogInitiated = true;
        }
    }
    wasWatchdogInitiated(socket) {
        var broker = this.$rootScope.webSocketKeepAliveBroker;
        return !!broker && broker.socket === socket && broker.watchdogInitiated;
    }
}
exports.WebSocketKeepAliveBrokerService = WebSocketKeepAliveBrokerService;
angular.module('callX').service('WebSocketKeepAliveBrokerService', ['$rootScope', WebSocketKeepAliveBrokerService.factory]);
